import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FacebookFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.9999 12.0327C20.9999 7.06219 16.9704 3.03271 11.9999 3.03271C7.02936 3.03271 2.99988 7.06219 2.99988 12.0327C2.99988 16.2534 5.9058 19.795 9.82584 20.7678V14.7831H7.97004V12.0327H9.82584V10.8476C9.82584 7.78436 11.2122 6.36452 14.2196 6.36452C14.7899 6.36452 15.7738 6.47648 16.1762 6.58808V9.08108C15.9638 9.05876 15.5948 9.0476 15.1366 9.0476C13.6609 9.0476 13.0907 9.60668 13.0907 11.06V12.0327H16.0304L15.5254 14.7831H13.0907V20.9668C17.5471 20.4286 21.0002 16.6342 21.0002 12.0327H20.9999Z" />
    </SvgIcon>
  );
});
